import { render, staticRenderFns } from "./AddBigScreet.vue?vue&type=template&id=232ff767&scoped=true&"
import script from "./AddBigScreet.vue?vue&type=script&lang=js&"
export * from "./AddBigScreet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232ff767",
  null
  
)

export default component.exports